export default __webpack_public_path__ + "static/media/trendDataIcon.3439b9dc.svg";